import React, {useEffect, useRef, useState} from 'react';
import {getFilterProductLine} from "../../microComponents/tablePages/getFilterProductLine";
import {Button, Input, QRCode, Select, Table} from "antd";
import Cookies from 'js-cookie';
import ProductSeries from "../../http_request/Model/ProductSeries/ProductSeries";
import ComponentCard from "../../microComponents/elements/ComponentCard";
import Title from "../../microComponents/elements/Title";
import {useReactToPrint} from 'react-to-print';

import {toast} from "react-toastify";
import Pallet from "../../http_request/Model/pallet/Pallet";
import PalletIdProductionColumn from "./PalletIdProductionColumn";
import Boxes from "./Boxes";
import PrintPage from "./PrintPage";

const PalletIdProduction = () => {
    const [productLineLoading, setProductLineLoading] = useState(false);
    const [filterProductLine, setFilterProductLine] = useState([]);
    const [seriId, setSeriId] = useState('');
    const [selectedLine, setSelectedLine] = useState();
    const [data, setData] = useState({});
    const [errorText, setErrorText] = useState('');
    const [data2, setData2] = useState({});
    const [numberPerPallet, setNumberPerPallet] = useState('');
    const [columns] = PalletIdProductionColumn();
    const [loadingTable, setLoadingTable] = useState(false);
    const [dataRows, setDataRows] = useState([]);
    const [getAgain, setGetAgain] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [countArray, setCountArray] = useState([])
    const printRef = useRef()
    console.log(data2)
    useEffect(() => {
        getFilterProductLine(setFilterProductLine, setProductLineLoading)
    }, []);
    useEffect(() => {
        let x = Number(Cookies.get('ProductLine'))
        setSelectedLine(x || '')
    }, []);
    useEffect(() => {


        if (selectedLine) {
            ProductSeries.request({
                beforeSend: () => {


                    // setLoadingProductSeries(true)
                }, success: (result) => {
                    setData(result?.result[0])
                    // setData({})


                    setCountArray([...Array(result?.result[0].printNumber).keys()].map(i => i + 1))
                    if (!result?.result[0]?.seriesStatus) {

                        setErrorText('سری تولید غیر فعال است.')
                    } else {

                        setErrorText('')
                    }


                    setSeriId(result?.result[0].id)
                    // dispatch(getAgainHandler());

                }, error: (error) => {


                    if (error.response.status === 400) {

                        setErrorText("سری فعال برای این خط وجود ندارد.")

                    }
                }, final: () => {
                    // setLoadingProductSeries(false)
                }


            }).ProductSeriesProductionLine(selectedLine)

        }

    }, [selectedLine, getAgain]);

    useEffect(() => {
        if (data.id) {
            Pallet.request({
                beforeSend: () => {
                }, success: (result) => {
                    setDataRows(result.result)
                }, error: (error) => {
                    toast.error(error.data.message);

                }, final: () => {
                },
            }).addParams({ProductSeri: data?.id, palletStatus: 1, page: 1, page_size: 1000}).palletList();

        }
    }, [JSON.stringify(data), getAgain]);
    useEffect(() => {
        if (data.numberPerPallet) {

            setNumberPerPallet(data.numberPerPallet)
        }
    }, [seriId,JSON.stringify(data)]);


    const showPrint = useReactToPrint({
        content: () => printRef.current,

        onAfterPrint: () => {
            setNumberPerPallet(data.numberPerPallet)
        },


    });
    useEffect(() => {

        if (data2?.productLine && numberPerPallet) {
             setTimeout(() => {

                showPrint()

            }, 30);
        }
    }, [JSON.stringify(data2)]);
    const handlePrint = () => {


        if (data.numberPerPallet >= numberPerPallet) {
            setData2({})
            setDisabled(true)
            setGetAgain(!getAgain)
            Pallet.request({
                beforeSend: () => {
                    setLoadingTable(true)
                }, success: ({result}) => {

                    setTimeout(() => {

                        setDisabled(false)
                    }, 5000);
                    setData2(result[0])


                }, final: () => {
                    setLoadingTable(false)
                }


            }).addParams({product_line: selectedLine, number: numberPerPallet}).printPallet()
        } else {
            toast.error(`مقدار وارد شده از پیش فرض بیشتر است.  `);
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setGetAgain(prevState => !prevState)
        }, 10000);
        return () => clearInterval(interval);
    }, [])


    return (<>
        <ComponentCard>


            <div className='flex justify-between'>
                <Title>پرینت شناسه</Title>
                <Select showSearch placeholder='خط تولید' style={{width: '200px'}}
                        loading={productLineLoading}
                        filterOption={(input, option) => {
                            return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                        }}
                        onChange={(e) => {
                            setSelectedLine(e)
                            setData({})
                            setNumberPerPallet('')
                            setErrorText('')
                            Cookies.set('ProductLine', e)
                        }}
                        optionFilterProp='label'
                        defaultValue={selectedLine}
                        value={selectedLine}
                        options={filterProductLine}/>

            </div>
        </ComponentCard>


        <Boxes data={data}/>
        <ComponentCard>


            <div className='border '>
                <div className="grid text-center text-sm font-bold grid-cols-2">
                    <div className=" border p-2   ">
                        <h1>شرکت بهنوش ایران</h1>

                    </div>

                    <div className="border p-2   ">
                        <h1>{data?.branch}-{data?.productLine}</h1>

                    </div>


                </div>
                <div className="border p-1 py-2">
                    <h2 className='text-center text-lg font-bold'>{data?.product}</h2>
                </div>


                <div className="grid grid-cols-3">

                    <div className="border p-2">
                        <div className="flex items-center gap-2">
                            <div className="key !text-sm !text-gray-800">ق م:</div>
                            <div className="value !text-black">{dataRows[0]?.consumerPriceRials}</div>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="key !text-sm !text-gray-800">ق ت:</div>
                            <div className="value !text-black">{dataRows[0]?.manufacturerPriceRials}</div>
                        </div>

                    </div>
                    <div className="border p-2">
                        <div className="flex items-center gap-2   justify-center  ">
                            <div className="key !text-sm !text-gray-800 whitespace-nowrap">تعداد در پالت:</div>
                            <div className="value !text-black">
                                {/*{numberPerPallet}*/}

                                <Input value={numberPerPallet} onChange={(e) => {
                                    setNumberPerPallet(e.target.value)
                                }}/>


                            </div>
                        </div>
                    </div>
                    <div className="border p-2">
                        <div className="flex items-center gap-2">
                            <div className="key !text-sm !text-gray-800">شماره بچ:</div>
                            <div className="value !text-black">{dataRows[0]?.batchNumber}</div>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="key !text-sm !text-gray-800">شماره پالت:</div>
                            <div className="value !text-black">{data.printedCounter}</div>
                        </div>

                    </div>
                </div>

                <div className="grid grid-cols-2">
                    <div className="border p-2">
                        <div className="flex items-center gap-2">
                            <div className="key !text-sm !text-gray-800">تاریخ تولید:</div>
                            <div className="value !text-black">{dataRows[0]?.dateOfManufacture}</div>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="key !text-sm !text-gray-800">تاریخ انقضا:</div>
                            <div className="value !text-black">{dataRows[0]?.expireDate}</div>
                        </div>


                    </div>
                    <div className="border p-2">
                        <div className="flex items-center gap-2  mb-1">
                            <div className="key !text-sm !text-gray-800">کنترل کیفی:</div>
                            <div className="value !text-black">{dataRows[0]?.qualityControlSupervisor}</div>
                        </div>
                        <div className="flex items-center gap-2  ">
                            <div className="key !text-sm !text-gray-800">سرپرست تولید:</div>
                            <div className="value !text-black">{dataRows[0]?.seriCreateBy}</div>
                        </div>
                    </div>
                </div>


                <div className="border p-2">
                    <div className="flex items-center justify-between">
                        <div className='hidden md:block'><QRCode value='iotfig.com'/></div>
                        <div><Button disabled={!data.seriesStatus || !data.id || disabled} onClick={handlePrint}
                                     className={`defBtn w-full !px-10 !py-6 ${!data.seriesStatus || !data.id ? '!bg-gray-400 !text-white' : 'blueBtn'}`}>پرینت
                            شناسه پالت</Button>


                            <p className='text-center text-sm font-bold mt-2 text-red-600'>{errorText}</p>


                        </div>
                        <div className='hidden md:block'><QRCode value='iotfig.com'/></div>

                    </div>
                </div>
            </div>


        </ComponentCard>{dataRows.length ?

        <ComponentCard>
            <Table
                columns={columns}

                dataSource={dataRows} loading={loadingTable}
                pagination={false}/>
        </ComponentCard> : null}


        <div ref={printRef} className="print-source">


            {countArray.map(i => (

                <PrintPage data={data2} numberPerPallet={numberPerPallet}/>))}


        </div>
    </>);
};

export default PalletIdProduction;